import gsap from 'gsap'
import store from './store'

export default class PopUpForm {
  constructor(formId) {
    this.formOpened = false
    this.lenis = store.smoothScroll
    this.formId = formId
    this.getElems()
    this.gsapSet()
    this.initObserver()
    this.events()
  }

  getElems() {
    // Select the elements that match this form's ID
    this.fixedButton = document.querySelector(`.e-button-pop-up-form[data-form-id="${this.formId}"]`)
    this.openButtons = document.querySelectorAll(`.--open-pop-up-form[data-form-id="${this.formId}"]`)
    this.popUp = {
      el: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"]`),
      content: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__content`),
      close: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__content__close`),
      background: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__background`)
    }
    this.submitButton = null
    this.requiredFields = []
  }

  gsapSet() {
    if (this.popUp.el) {
      gsap.set(this.popUp.el, {
        visibility: 'hidden',
        opacity: 0
      })

      gsap.set(this.popUp.content, {
        xPercent: 100
      })

      gsap.set(this.popUp.background, {
        opacity: 0
      })
    }
  }

  initObserver() {
    const popUpEl = this.popUp.el

    if (!popUpEl) return

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          this.submitButton = document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .e-button`)
          this.requiredFields = [...document.querySelectorAll(`.c-pop-up-form[data-form-id="${this.formId}"] [aria-required="true"]`)]

          if (this.submitButton) {
            this.submitButton.disabled = true
            this._attachFormEvents()
            observer.disconnect()
          }
        }
      })
    })

    observer.observe(popUpEl, {
      childList: true,
      subtree: true
    })
  }

  events() {
    if (this.fixedButton) {
      this.fixedButton.addEventListener('click', () => {
        this._openForm()
      })
    }

    if (this.popUp.el) {
      document.addEventListener('click', (e) => {
        if (this.formOpened && !this.popUp.content.contains(e.target)) {
          this._closeForm()
        }
      })

      this.popUp.close.addEventListener('click', () => {
        this._closeForm()
      })

      this.popUp.background.addEventListener('click', () => {
        this._closeForm()
      })

      this.popUp.content.addEventListener('wheel', (e) => e.stopPropagation())

      if (this.openButtons) {
        this.openButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this._openForm()
          })
        })
      }
    }
  }

  _attachFormEvents() {
    if (!this.submitButton) return

    this._checkRequiredFields = this._checkRequiredFields.bind(this)
    const formElement = document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"]`)

    if (formElement) {
      formElement.addEventListener('input', this._checkRequiredFields)
      formElement.addEventListener('change', this._checkRequiredFields)
    }
  }

  _checkRequiredFields() {
    let allFieldsValid = true

    this.requiredFields.forEach((field) => {
      if (!field.value || field.type === 'checkbox' && !field.checked) {
        allFieldsValid = false
      }
    })

    this.submitButton.disabled = !allFieldsValid
  }

  _openForm() {
    const tlOpen = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'power3.out'
      },
      onComplete: () => {
        this.formOpened = true
      }
    })

    tlOpen.to(this.popUp.el, {
      visibility: 'visible',
      opacity: 1,
      duration: 0
    })
    .to(this.popUp.background, {
      opacity: 1
    })
    .to(this.popUp.content, {
      xPercent: 0
    }, '<+0.2')

    tlOpen.play()
  }

  _closeForm() {
    const tlClose = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'power3.out'
      },
      onComplete: () => {
        this.formOpened = false
      }
    })

    tlClose.to(this.popUp.content, {
      xPercent: 100
    })
    .to(this.popUp.background, {
      opacity: 0
    }, '<+0.2')
    .to(this.popUp.el, {
      visibility: 'hidden',
      opacity: 0,
      duration: 0
    })

    tlClose.play()
  }
}
